import styled from "@emotion/styled";
import colors from "styles/colors";
const thumbnailHeight = "320px";
const imageHeight = "240px";
const textBaseHeight = `calc(${thumbnailHeight} - ${imageHeight})`;
export const StyledBackgroundImageThumbnailItemComponent = styled.a`
  position: relative;

  height: 320px;
  width: 300px;
  overflow: hidden;

  margin: 20px;
  border-radius: 4px;

  background-color: ${colors["white"]};

  transition: 0.2s ease-in-out all;
  text-decoration: none;

  cursor: pointer;

  .image-container {
    height: ${imageHeight};
    opacity: 1;
    width: 100%;

    transition: 0.2s opacity ease;
  }

  .hover-decorator-container {
    display: none;

    position: absolute;
    right: 16px;
    top: 16px;

    font-size: 1rem;
    font-weight: 400;

    color: ${colors["black"]};
  }

  .text-container {
    position: absolute;
    bottom: 0;

    height: ${textBaseHeight};
    overflow: hidden;

    padding: 0 24px;
    transition: 0.2s height ease;

    color: ${colors["black"]};
    background-color: ${colors["white"]};

    .thumbnail-title-wrapper {
      height: 100%;

      width: 252px;

      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: center;

      margin-bottom: 8px;

      .thumbnail-title {
        font-size: 1.375rem;

        width: 100%;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .thumbnail-title-decorator {
        color: ${colors["brand-gray"]};
        font-size: 0.875rem;
      }
    }

    .thumbnail-subtitle {
      display: flex;

      font-size: 0.8125rem;
      line-height: 20px;

      margin-bottom: 8px;
    }

    .buttom-link-container {
      font-size: 0.8125rem;
      color: ${colors["light-blue"]};
      text-decoration: underline;
    }
  }

  &:hover {
    .image-container {
      opacity: 0.5;
    }

    .hover-decorator-container {
      display: block;
    }

    .text-container {
      height: 120px;
      padding: 0 24px;

      display: flex;
      flex-direction: column;
      justify-content: center;

      .thumbnail-title-wrapper {
        height: auto;
      }
    }

    &.extended-hover-height {
      .text-container {
        height: 160px;
      }
    }
  }
`;
